import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import 'babel-polyfill';
import 'isomorphic-fetch';
import 'es6-promise';
import 'whatwg-fetch';
import rootReducer from './reducers';
import App from './components/App';

export const store = createStore(rootReducer, applyMiddleware(thunk));

ReactDOM.render(
	<Provider store={store}>
		<App/>
	</Provider>, document.getElementById('root')
);